import React from 'react';
import Tooltip from '@mui/material/Tooltip';
import ShareTwoToneIcon from '@mui/icons-material/ShareTwoTone';
import IconButton from '@mui/material/IconButton';

interface Props {
  handleShareClick: () => void,
}

const ShareInteraction: React.FC<Props> = ({ handleShareClick }) => (
  <Tooltip placement="top" title="Share" arrow>
    <IconButton id="composition-button" onClick={handleShareClick} size="small">
      <ShareTwoToneIcon />
    </IconButton>
  </Tooltip>
);

export default ShareInteraction;
